import React, {memo} from "react";
import moment from "moment";
import {Table, TableBody, TableRow, TableCell, TablePagination, Checkbox, Icon, IconButton} from "@material-ui/core";
import ServicesTableHead from "./ServicesTableHead";
import CustomButton from "../../../../components/CustomButton";
import useIsMobile from "../../../../hooks/useIsMobile";
import "./index.scss";


const ServicesTable = ({
    mobile = false,
    services,
    selectedServices,
    order, count, page,
    rowsPerPage,
    onSelect, onSelectAll,
    onCancelServices,
    onCancelService,
    onSort, onChangePage,
    onChangeRowsPerPage
}) => {
    let isMobile = useIsMobile(900);
    let isMobilePagination = useIsMobile(600);

    if(mobile) {
        isMobile = true;
        isMobilePagination = true;
    }

    return (
        <div className="services-table">
            <Table stickyHeader className="services-table__table">
                <ServicesTableHead
                    isMobile={isMobile}
                    selectedServices={selectedServices}
                    services={services}
                    order={order}
                    onSelectAll={onSelectAll}
                    onSort={onSort}
                    onCancelServices={onCancelServices}
                />
                <TableBody>
                    {isMobile ?
                        services.map(service =>
                            <TableRow
                                key={`table-row${service.id}`}
                                className="services-table__row"
                                selected={!!selectedServices.find(id => id === service.id)}
                            >
                                <TableCell className="services-table__cell" padding="none">
                                    <Checkbox
                                        checked={!!selectedServices.find(item => item.id === service.id)}
                                        disabled={moment().isAfter(service.session_date) || service.status_id === 8}
                                        onClick={e => e.stopPropagation()}
                                        onChange={() => onSelect(service)}
                                    />
                                </TableCell>
                                <TableCell className="services-table__cell typografhy" component="th" scope="row">
                                    {service.service_name}
                                </TableCell>
                                <TableCell className="services-table__cell typografhy" component="th" scope="row">
                                    {moment(service.session_date).format('DD.MM в HH:mm')}
                                </TableCell>
                                <TableCell className="services-table__cell" >
                                    <IconButton
                                        onClick={() => onCancelService(service.id)}
                                        disabled={moment().isAfter(service.session_date) || service.status_id === 8}
                                    >
                                        <Icon className="services-table__icon-cancel">
                                            clear
                                        </Icon>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ) :
                        services.map(service =>
                            <TableRow
                                key={`table-row${service.id}`}
                                className="services-table__row"
                                selected={selectedServices.find(id => id === service.id) > -1}
                            >
                                <TableCell className="services-table__cell" padding="none">
                                    <Checkbox
                                        checked={!!selectedServices.find(item => item.id === service.id)}
                                        disabled={moment().isAfter(service.session_date) || service.status_id === 8}
                                        onClick={e => e.stopPropagation()}
                                        onChange={() => onSelect(service)}
                                    />
                                </TableCell>
                                <TableCell className="services-table__cell" padding="none">
                                    <CustomButton
                                        className='services-table__custom-button'
                                        onClick={() => onCancelService(service.id)}
                                        disabled={moment().isAfter(service.session_date) || service.status_id === 8}
                                    >
                                        Отмена
                                    </CustomButton>
                                </TableCell>
                                <TableCell className="services-table__cell" component="th" scope="row">
                                    {service.service_name}
                                </TableCell>
                                <TableCell className="services-table__cell" component="th" scope="row">
                                    {service.provider_name}
                                </TableCell>
                                <TableCell className="services-table__cell" component="th" scope="row">
                                    {moment(service.session_date).format('DD.MM.YYYY в HH:mm')}
                                </TableCell>
                                <TableCell className="services-table__cell" component="th" scope="row">
                                    {service.status_name}
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody>
            </Table>
            <TablePagination
                className="services-table__pagination"
                component="div"
                labelRowsPerPage={isMobilePagination ? '' : 'Услуг на странице'}
                backIconButtonText="Назад"
                nextIconButtonText="Вперед"
                labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count !== -1 ? count : `более чем ${to}`}`}
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={onChangePage}
                onRowsPerPageChange={onChangeRowsPerPage}
            />
        </div>
    )
};

export default memo(ServicesTable);